import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, onSnapshot, doc, addDoc, deleteDoc, updateDoc } from 'firebase/firestore';
import toast from 'react-hot-toast';

export const useCentroOperaciones = () => {
    const [productos, setProductos] = useState([]);
    const [cargando, setCargando] = useState(true);

    // VALORES MAESTROS RESTAURADOS CON LA NUEVA FÓRMULA DE 11.62€
    const parametrosSL = {
        gastosFijosMensuales: 12267.20, // Visual del Dashboard
        gastosFijosPorHora: 11.62,      // Nuevo valor actualizado maestro
        porcentajeSeguridadSocial: 0.32,
        costoHoraBaseCarpinteria: 12.00,
        costoHoraBaseTapiceria: 12.00,
        margenBeneficioDeseado: 0.20 // 20%
    };

    useEffect(() => {
        const unsubscribe = onSnapshot(collection(db, "costos_produccion"), (snapshot) => {
            const data = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setProductos(data);
            setCargando(false);
        }, (error) => {
            console.error("Error al cargar:", error);
            toast.error("Error cargando base de datos");
            setCargando(false);
        });

        return () => unsubscribe();
    }, []);

    const calcularEstructuraCosto = (materialesBase, horasProduccion, gastoFijoHora) => {
        const mat = parseFloat(materialesBase) || 0;
        const horas = parseFloat(horasProduccion) || 0;
        const fijoHora = parseFloat(gastoFijoHora) || parametrosSL.gastosFijosPorHora;

        const costoHoraEmpresa = parametrosSL.costoHoraBaseCarpinteria * (1 + parametrosSL.porcentajeSeguridadSocial);
        const costoManoObraTotal = costoHoraEmpresa * horas;
        const absorcionGastosFijos = horas * fijoHora;
        const costoTotalEmpresa = mat + costoManoObraTotal + absorcionGastosFijos;

        return { costoManoObraTotal, absorcionGastosFijos, costoTotalEmpresa };
    };

    const calcularPVP = (costoTotalEmpresa) => {
        const pvpSinIva = costoTotalEmpresa / (1 - parametrosSL.margenBeneficioDeseado);
        const iva = pvpSinIva * 0.21;
        const pvpConIva = pvpSinIva + iva;
        return { pvpSinIva, pvpConIva };
    };

    const agregarProducto = async (nuevo) => {
        try {
            await addDoc(collection(db, "costos_produccion"), {
                producto: nuevo.producto,
                materiales: parseFloat(nuevo.materiales) || 0,
                horas: parseFloat(nuevo.horas) || 0,
                gastoFijoHora: parseFloat(nuevo.gastoFijoHora) || parametrosSL.gastosFijosPorHora,
                departamento: nuevo.departamento || 'C',
                createdAt: new Date().toISOString()
            });
            toast.success("Producto guardado");
        } catch (error) {
            toast.error("Error al guardar");
        }
    };

    const editarProducto = async (id, datosEditados) => {
        try {
            await updateDoc(doc(db, "costos_produccion", id), {
                materiales: parseFloat(datosEditados.materiales) || 0,
                horas: parseFloat(datosEditados.horas) || 0
            });
            toast.success("Producto actualizado correctamente");
        } catch (error) {
            toast.error("Error al actualizar");
        }
    };

    const eliminarProducto = async (id) => {
        if (window.confirm("¿Seguro que deseas eliminar este registro?")) {
            try {
                await deleteDoc(doc(db, "costos_produccion", id));
                toast.success("Registro eliminado");
            } catch (error) {
                toast.error("Error al eliminar");
            }
        }
    };

    return {
        productos,
        cargando,
        parametrosSL,
        calcularEstructuraCosto,
        calcularPVP,
        agregarProducto,
        editarProducto,
        eliminarProducto
    };
};